import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(
    private http: HttpClient
  ) { }

  public async listAllCategories(): Promise<any> {
    return this.http.get<any>(`/category/list`).toPromise();
  }
}
